// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1YgSf","iframe":"styles_iframe__1XHBq","hiddenFooter":"styles_hiddenFooter__fbD_J"};